<template>
    <div>
        <img :src="imgPath">
        <span>{{ getString('powered_by') }}</span>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import eventModule from '@/assets/libs/eventModule'
export default {
    name: 'Poweredby',
    data () {
        return {
            imgPath: require('../../static/client/teknisa-branca.png'),
            lang: LocaleController.getCurrentLanguage()
        }
    },
    created () {
        eventModule.$on('languageChosen', () => { this.$forceUpdate() })
    },
    beforeDestroy () {
        eventModule.$off('languageChosen')
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");
    .poweredby{
        position: fixed;
        background: black;
        height: 60px;
        bottom: 0;
        width: 100vw;
    }
    img {
        transform: translate(-50%, -50%);
        left: 15%;
        top: 50%;
        position: relative;
        display: block;
        height: 40px;
    }

    span {
        position: absolute;
        right: 30%;
        top: 50%;
        transform: translate(50%, -50%);
        color: white;
        font-size: 26px;
        font-weight: bold;
    }

    @media (max-width: 698px) { // Gertec SK210
        .poweredby {
            height: 30px;
        }
        img {
            height: 20px;
        }
        span {
            font-size: 9px;
        }
    }
    @media (orientation: landscape) {
        .poweredby {
            // height: 30px;
        }
        img {
            height: 25px;
        }
        span {
            font-size: 14px;
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { // @tablet
        .poweredby {
            height: 60px;
        }
        img {
            height: 28px;
        }
        span {
            font-size: 16px;
        }
    }

    @media (orientation: landscape) and (min-width: 1000px) {
        .poweredby {
            height: 30px;
        }
        img {
            height: 25px;
        }
        span {
            font-size: 12px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Poweredby.vue